import React, { useState, useEffect } from 'react';
import './SuccessPopup.css'; // You'll need to create this CSS file

const SuccessPopup = ({ isVisible, onClose, message = "Form submitted successfully!" }) => {
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShowAnimation(true);
      // Auto close after 5 seconds
      const timer = setTimeout(() => {
        onClose();
      }, 5000);
      
      return () => clearTimeout(timer);
    } else {
      setShowAnimation(false);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  return (
    <div className="success-popup-overlay" onClick={onClose}>
      <div className="success-popup-container" onClick={(e) => e.stopPropagation()}>
        <div className="success-popup-content">
          {/* Animated Check Icon */}
          <div className={`success-icon-wrapper ${showAnimation ? 'animate' : ''}`}>
            <div className="success-icon">
              <div className="success-icon-circle">
                <div className="success-icon-check"></div>
              </div>
            </div>
          </div>
          
          {/* Success Message */}
          <h3 className="success-title">Success!</h3>
          <p className="success-message">{message}</p>
          
          {/* Buttons */}
          <div className="success-buttons">
            <button className="btn-ok" onClick={onClose}>OK</button>
            {/* <button className="btn-close" onClick={onClose}>×</button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPopup;